var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-search"},[_c('document-list',{on:{"handleSelectDate":_vm.handleSelectDate}}),_c('documents',{attrs:{"month":_vm.selectMonth,"year":_vm.selectYear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }